import { useMemo } from "react";

import { useUserPreferences } from "@/context/UserPreferencesContext";
import { formatInsightDisplayText } from "@/lib/formatInsightDisplay";
import { extractLaneLocodes } from "@/lib/formatPort";

import { usePortNames } from "./usePortNames";

/** Format a stored insight title/summary for the current user's port prefs. */
export function useInsightDisplayText(text: string | null | undefined): string {
  const { preferences } = useUserPreferences();
  const locodes = useMemo(() => extractLaneLocodes(text), [text]);
  const portNames = usePortNames(locodes);
  return useMemo(
    () =>
      formatInsightDisplayText(text, {
        showLocodes: preferences.showLocodes,
        portNames,
      }),
    [text, preferences.showLocodes, portNames],
  );
}
